import { BrowserRouter, HashRouter, Route, Routes } from 'react-router';

import { platform } from '@platform';

import { HowProvider, HowRedirect } from '@/components/HowBridgeWorks';
import { NearbyProvider } from '@/components/Nearby';
import { QuickSendHost } from '@/components/QuickSendHost';
import { ToastProvider } from '@/components/Toast';
import { BridgePage } from '@/pages/BridgePage';
import { ConnectPage } from '@/pages/ConnectPage';
import { DevelopersPage } from '@/pages/DevelopersPage';
import { CasesPage } from '@/pages/CasesPage';
import { HomePage } from '@/pages/HomePage';
import { NotFoundPage } from '@/pages/NotFoundPage';

export function AppRoutes(): React.JSX.Element {
  return (
    <ToastProvider>
      <QuickSendHost />
      <NearbyProvider>
        <HowProvider>
          <Routes>
            <Route path="/" element={<HomePage />} />
            {/* the address other sites put in a frame (lib/embed.ts); the tool itself is the home page */}
            <Route path="/embed" element={<HomePage />} />
            <Route path="/b/:id" element={<BridgePage />} />
            <Route path="/connect" element={<ConnectPage />} />
            {/* “How it works” used to be a page of its own; it is now a window over the app. */}
            <Route path="/about" element={<HowRedirect />} />
            <Route path="/developers" element={<DevelopersPage />} />
            <Route path="/cases" element={<CasesPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
        </HowProvider>
      </NearbyProvider>
    </ToastProvider>
  );
}

/**
 * The server build uses clean URLs (the Node server falls back to index.html).
 * The single-file demo has no server, so it routes through the hash.
 */
export function App(): React.JSX.Element {
  if (platform.router === 'hash') {
    return (
      <HashRouter>
        <AppRoutes />
      </HashRouter>
    );
  }
  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}
